import { render, staticRenderFns } from "./Loading1.vue?vue&type=template&id=2d6c9a4c&scoped=true&"
import script from "./Loading1.vue?vue&type=script&lang=js&"
export * from "./Loading1.vue?vue&type=script&lang=js&"
import style0 from "./Loading1.vue?vue&type=style&index=0&id=2d6c9a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c9a4c",
  null
  
)

export default component.exports